// extracted by mini-css-extract-plugin
export default {"container":"SelectStage_container__oEPWo","left":"SelectStage_left__VFXID","right":"SelectStage_right__jFdAV"};